import { render } from "./TrainingComponent.vue?vue&type=template&id=b7122872"
import script from "./TrainingComponent.vue?vue&type=script&lang=js"
export * from "./TrainingComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__